<template>
  <div class="app-footer container-fluid">
    <div class="container px-3 mx-auto">
      <div class="row py-5">
        <div class="col-md-8 col-6">
          <div class="row d-flex justify-content-between">
            <div class="d-flex flex-column pb-4">
              <h5 class="title-btm pb-3">Information</h5>
              <p class="mb-0 text-muted">
                Contact us
                <span class="blue-text">beep@ease.com</span>
              </p>
              <p class="mb-0 text-muted">Start learning</p>
              <p class="mb-0 text-muted">Become a mentor</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "foot",
};
</script>

<style scoped>
body {
  overflow-x: hidden;
}

a {
  color: #fff;
}

a:hover {
  color: #e0e0e0;
}

.line {
  background-color: lightgrey;
  width: 50px;
  margin: 12px 7px 25px 7px;
  border-radius: 50px;
}

.box {
  width: 30%;
  padding: 30px 30px 35px 30px;
  margin-bottom: 20px;
  height: 400px;
  position: relative;
}

.app-footer {
  background-color: rgba(84, 72, 226, 0.04);
}
.app-footer .container{
  background-color: transparent;
}

.text-muted {
    font-size: 14px;
}

.sm-text {
  font-size: 14px;
}

.bottom {
  bottom: 20px;
  position: absolute;
  width: 150px;
}

/* .mt-large {
  margin-top: 120px;
} */

.title-btm {
  font-weight: bold;
}

select {
  border: 1px solid lightgrey;
}

.red-text {
  color: red;
  cursor: pointer;
}

.blue-text {
  color: rgb(33, 2, 146);
  cursor: pointer;
}

.red-text:hover {
  text-decoration: underline;
}

.footer-line {
  border-top: 1px solid lightgrey;
}
</style>